export default {
  'oss.oss-config.scheme': 'URL 协议',
};
